import { Lookup, useLookup } from '@/providers'
import { Autocomplete, TextField } from '@mui/material'
import { UrlUpdateType } from 'use-query-params'

type Props = {
	value: number | string | null
	updateFilters: (changes: any, updateTypeOverride?: UrlUpdateType) => void
}

export default function ReviewType({ value, updateFilters }: Props) {
	const options = useLookup(Lookup.ReviewTypes)

	const selectedValues = options.find((v) => v.id === value) || null

	const handleChange = (e, value) => {
		if (value) {
			updateFilters({ reviewType: value.id })
		} else {
			updateFilters({ reviewType: null })
		}
	}

	return (
		<Autocomplete
			fullWidth
			size="small"
			options={options}
			value={selectedValues}
			onChange={handleChange}
			renderInput={(params) => <TextField {...params} label="Review Type" />}
			slotProps={{ paper: { style: { width: '24rem' } } }}
		/>
	)
}
